module.exports = __webpack_public_path__ + "img/b_3.3093db27.png";